const LlmIcon = ({ width = "23", height = "23", color = "var(--border)" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill="none"
    stroke={color}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round">
    <rect x="5" y="5" width="14" height="14" rx="2.5" />
    <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
    <path d="M8.5 15l1.75-6h.5L12.5 15M9.1 13h2.8M15 9v6" />
  </svg>
);

export default LlmIcon;
